<template>
    <div class="layout-footer">
        <div class="footer-logo-container">
            <img id="footer-logo" src="layout/images/logo-dark.svg" alt="diamond-layout" />
            <span class="app-name">xlite-web</span>
        </div>
        <Versions />
        <span class="copyright">&#169; SLware Srl - {{ new Date().getFullYear() }}</span>
    </div>
</template>

<script>
import Versions from '@/components/Versions.vue'

export default {
    name: "AppFooter",
    components: {
        Versions
    }
}
</script>